import { LocationActionPayload, LocationChangePayload } from 'connected-react-router';

export enum Types {
  LOCATION_CHANGED = '@@router/LOCATION_CHANGE',
  PUSH = '@@router/CALL_HISTORY_METHOD',
  REPLACE = '@@router/CALL_HISTORY_METHOD',

  REPLACE_QUERY = 'Router:ReplaceQuery',
  UPDATE_QUERY = 'Router:UpdateQuery',
}

interface LocationChangeAction {
  type: Types.LOCATION_CHANGED;
  payload: LocationChangePayload;
}

interface HistoryMethodAction {
  type: Types.PUSH | Types.REPLACE;
  payload: LocationActionPayload;
}

interface QueryAction {
  type: Types.UPDATE_QUERY | Types.REPLACE_QUERY;
  payload: {
    query: {
      [key: string]: string;
    };
    replacePath: boolean;
  };
}

export type Action = LocationChangeAction | HistoryMethodAction | QueryAction;
